<template>
  <div class="py-6">
    <transition name="fadeLoader">
      <PageLoader v-if="!category || !videos" ref="loadingOverlay" />
    </transition>
    <VideoCarousel
      v-if="category && videos"
      :title="category.name"
      :videos="videos"
      :link="{ name: 'Category', params: { slug: category.slug } }"
    />
  </div>
</template>

<script>
import VideoCarousel from "@/components/UI/Video/VideoCarousel";
import PageLoader from "@/components/UI/Loader/PageLoader";
import axios from "axios";
export default {
  name: "CategoryCarousel",
  data() {
    return {
      videos: null,
    };
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  components: {
    PageLoader,
    VideoCarousel,
  },
  mounted() {
    this.getVideos();
  },
  methods: {
    getVideos() {
      axios
        .get("/videos", {
          params: {
            categories: [this.category.slug],
            order_by_column: "likes",
            order_by_direction: "desc",
          },
        })
        .then((response) => {
          this.videos = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
</style>